export const undoable = (state, getters) => {
  return state.undoBufferCursor > 0;
};

export const redoable = (state, getters) => {
  return typeof state.undoBuffer[state.undoBufferCursor + 1] !== 'undefined';
};



// WEBPACK FOOTER //
// ./src/store/undo/undoGetters.js